import React, { Component } from "react";
import CardBox from "components/CardBox/index";
import IntlMessages from "util/IntlMessages";
import TextField from "components/Core/TextField/index";

import { useForm } from 'util/validatorWithTooltip';
import BaseComponent from 'components/BaseComponent/index';
import AuthUserService from "services/AuthUserService";
import ClientRequestService from "services/ClientRequestService";
import { Button } from "reactstrap";


class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.dataHandlerService = new ClientRequestService('Security');

        let authentication = new AuthUserService();
        let user = authentication.getUser();

        this.change = {
            userId: user ? user.UserID : 0,
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: ""
        };

        this.state = {
            change: { ...this.change },
            keyModel: 'change',
            keyPropChangeable: false,
            keyProp: 'userId',
            isValidForm: false,
            showSearch: false,
            mountLocalizedComponents: false,
            mountLazyComponents: false,
            minifinder: true,
            buttonPrivileges: {
                showNew: false,
                showCreate: false,
                showUpdate: false,
                showSearch: false,
                showClear: false,
                showDelete: false
            }
        };

        this.baseComponent = React.createRef();
    }

    handleSubmit = ({ userId, currentPassword, newPassword, confirmNewPassword }) => {
        this.dataHandlerService.Put({
            url: `User/ChangePassword`,
            data: { UserId: userId, CurrentPassword: currentPassword, NewPassword: newPassword, ConfirmNewPassword: confirmNewPassword }
        }).then(() => {
            this.dataHandlerService.util.showNotificationMsg('Password changed successfully.', 'success');
            this.baseComponent.current.clear(this);
            //this.props.history.push('/SignIn');
            //this.props.history.push('/');
        });
    }
    actionMethods = {
        update: () => {
            /* this.baseComponent.current.save(
                this,
                'Security/User/ChangePassword',
                true,
                null,
                (saveModel) => {
                    return saveModel;
                },
                () => {
                    this.baseComponent.current.clear(this);
                }
            ); */
        }
    };

    componentDidMount() {
        this.setState({ mountLocalizedComponents: true });
        this.baseComponent.current.setModelState(null, 'Modified');
    }

    /*componentDidUpdate(prevProps, prevStates) {
        if (this.state.loadAtStartUp !== prevStates.loadAtStartUp) {
            this.baseComponent.current.load(this, 'User', 'Get');
        }
    }*/

    render() {
        return (
            <div>
                <div className='app-wrapper'>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-6'>
                            <FormWithValidation parent={this} />
                        </div>
                    </div>
                </div>
                <BaseComponent module='Security' privileges={{ CanCreate: false, CanRead: true, CanUpdate: true, CanDelete: false }} buttonPrivileges={this.state.buttonPrivileges} parameters={this.props.parameters} /* actionMethods={{ ...this.actionMethods, search: this.search }} */ isValidForm={this.state.isValidForm} ref={this.baseComponent} />
            </div>
        );
    }
}

const FormWithValidation = ({ parent }) => {
    const { useInput } = useForm(
        parent, { ...parent.state.change }
    );

    return (
        <CardBox
            heading={<IntlMessages id='pages.changepassword' />}
            styleName='' cardStyle='Box' childrenStyle='' headerOutside='' headingStyle=''
            children={
                <div>
                    <div className='d-none'><TextField disabled label='User ID' {...useInput('userId', '', '')} /></div>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-12'>
                                    <TextField type='password' autoComplete='new-password' label='Current Password' required
                                        {...useInput('currentPassword', 'isRequired', 'Current password is required!')}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <TextField type='password' autoComplete='new-password' label='New Password' required
                                        {...useInput('newPassword', 'isRequired', 'New password is required!')}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <TextField type='password' autoComplete='new-password' label='Confirm New Password' required
                                        {...useInput('confirmNewPassword', 'isRequired', 'Confirm password is required!')}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                &nbsp;
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <Button
                                        onClick={() => {
                                            parent.handleSubmit({ ...parent.state.change });
                                        }}
                                        variant='contained'
                                        color='primary'>
                                        <IntlMessages id='appModule.submit' />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default ChangePassword;